import * as React from 'react';
import Divider from 'material-ui/Divider';
import { Grid, Row, Col } from 'react-flexbox-grid';
import Address, { AddressField } from '@components/form/Address/Address';
import { InputField, Input } from '@components/form';

const View: React.SFC<any> = () => (
  <div>
    <Grid fluid={true}>
      <Row>
        <Col className="grid-system-margin" />
      </Row>
      <Row>
        <Col md={12}>
          <Row>
            <Col md={12}>
              <h4>Adresa</h4>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <AddressField component={Address} name={'address'} disabled={true} />
            </Col>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <Row>
            <Col md={12}>
              <h4>Popis skutku</h4>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <InputField component={Input} name={'description'} disabled={true} multiLine={true} />
            </Col>
          </Row>
        </Col>
      </Row>

      <Row>
        <Col className="grid-system-margin" />
      </Row>
    </Grid>

    <Divider />
  </div>
);

export const DelictsFormAddress = View;



// WEBPACK FOOTER //
// ./src/modules/delicts/DelictsFormAddress.tsx